import {
  Autocomplete,
  Box,
  CircularProgress,
  styled,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDebounce } from "../../../helpers";

const PREFIX = "SearchContent";

const classes = {
  autocomplete: `${PREFIX}-autocomplete`,
};

const StyledDiv = styled("div")(({ theme }) => ({
  [`& .${classes.autocomplete}`]: {
    marginBottom: "1rem",
    [theme.breakpoints.between("xs", "md")]: {
      width: "100%",
    },
    width: "400px",
  },
}));

const SearchContent = ({
  isAsync = false,
  searchApi,
  id,
  baseOptions,
  selectedList,
  setResults,
  key = id,
}) => {
  const { t } = useTranslation();
  const [originalOptions] = useState(baseOptions);
  const [asyncInput, setAsyncInput] = useState("");
  const debouncedAsyncInput = useDebounce(asyncInput, 500);
  const [options, setOptions] = useState(baseOptions);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (debouncedAsyncInput.length > 0) {
      setLoading(true);
      searchApi(debouncedAsyncInput).then((res) => {
        setLoading(false);
        setOptions(res);
      });
    }
  }, [debouncedAsyncInput]); //eslint-disable-line

  if (isAsync)
    return (
      <StyledDiv>
        <Autocomplete
          className={classes.autocomplete}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.displayName || option.name}
          options={options}
          loading={loading}
          onChange={(e, value) => {
            setAsyncInput("");
            if (!value) setResults(originalOptions);
            else setResults([value]);
          }}
          renderOption={(props, option) => {
            return (
              <Box
                component="li"
                {...props}
                key={`${id}-autocomplete-option-${option.id}`}
              >
                {option.displayName || option.name}
              </Box>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("myExpariences.dmaAdminPage.searchAnElement")}
              value={asyncInput}
              onChange={(e) => {
                setAsyncInput(e.target.value);
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </StyledDiv>
    );
  else
    return (
      <StyledDiv>
        <Autocomplete
          className={classes.autocomplete}
          id={`autocomplete-dnd-${id}`}
          options={options.filter(
            (item) => !selectedList.map((elem) => elem.id).includes(item.id)
          )}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) => {
            if (!value) setResults(originalOptions);
            else setResults([value]);
          }}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label={t("myExpariences.dmaAdminPage.searchAnElement")}
            />
          )}
        />
      </StyledDiv>
    );
};

export default SearchContent;
